import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import unitJobs from "@frog/source/data/unit-jobs.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"
import convertOldOverworldScripting from "@frog/source/data/games/hero/convertOldOverworldScripting.js"

export default {
    "slug": "introduce-mercenary",
    // TODO: Tutorial Parity
    "stage": {
        // https://serenesforest.net/wp-content/uploads/2017/02/41.png
        "image": require("./image.png"),
        "imageOffset": {"x": -6, "y": -1},
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "width": 18,
            "height": 10,
        }),
        "text": (stage) => {
            if(stage.flags["tutorial:hasAttacked"] != true) {
                return "Click and drag your unit over the enemy"
            }
            if(stage.turn.number == 0) {
                return "Now hit the end turn button!"
            }
        },
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "spawngood"}),

                    "oriana: ENTERS",
                    "oriana: #position:4",
                    "oriana: #direction:left",
                    "oriana: Oof.. where am I?",
                    "oriana: I'll figure out where I am after I defeat these bandits. #expression:angry",
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                },
                "events": [
                    PlotSteps.ChapterSuccess(),
                    {"func": () => Navigation.go("/games/hero/overworld")},
                    PlotSteps.Wait(1000),
                    FinishLocation("1"),
                    PlotSteps.Wait(1000),
                    DisplayLocation("2"),
                    PlotSteps.Wait(500),
                    DisplayLocation("3"),
                    PlotSteps.Wait(500),
                    DisplayLocation("4"),
                    PlotSteps.Wait(500),
                    DisplayLocation("5"),
                    PlotSteps.Wait(1000),
                    DisplayRoute(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"]),
                    PlotSteps.Wait(1000),
                    UnlockLocation("2"),
                    UnlockRoute(["1", "2", "3"]),

                    "oriana: lorem ipsum hello hello placeholder here whadya know",

                    PlotSteps.DialogueChoice("oriana: do you think that the grinch is his name or his species?", "openquestion", ["Name", "Species"]),
                    PlotSteps.ifFlagIsValue("openquestion", "Name", [
                        "oriana: that's what i've been saying!! he must be some sort of who named the grinch, right?? #expression:happy"
                    ]),
                    PlotSteps.ifFlagIsValue("openquestion", "Species", [
                        "oriana: hm. i guess. #expression:angry"
                    ]),

                    "oriana: so anyway let's keep moving",
                ]
            },
            PlotScripts.ChapterFailure(),
        ],
    },
}

function DisplayLocation(locationKey) {
    return {
        "func": () => {
            App.game.overworld.locations[locationKey].isDisplayed = true
        }
    }
}

function DisplayRoute(routeKeys) {
    return {
        "func": () => {
            routeKeys.forEach((routeKey) => {
                App.game.overworld.routes[routeKey].isDisplayed = true
            })
        }
    }
}

function UnlockLocation(locationKey) {
    return {
        "func": () => {
            App.game.overworld.locations[locationKey].isReachable = true
            App.game.overworld.locations[locationKey].isDisplayed = true
        }
    }
}

function UnlockRoute(routeKeys) {
    return {
        "func": () => {
            routeKeys.forEach((routeKey) => {
                App.game.overworld.routes[routeKey].isReachable = true
                App.game.overworld.routes[routeKey].isDisplayed = true
            })
        }
    }
}

function FinishLocation(locationKey) {
    return {
        "func": () => {
            App.game.overworld.locations[locationKey].isFinished = true
        }
    }
}

// // https://serenesforest.net/wp-content/uploads/2017/02/41.png
// "introduce-mercenary": {
//     "hasTutorial": true,
//     "hasPreparation": false,
//     "music": "hero-alt",
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/brook.png"),
//         "tiles": [
//             {"position": {"x": 0, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 3}, "passable": false},
//             {"position": {"x": 2, "y": 3}, "passable": false},
//             {"position": {"x": 3, "y": 3}, "passable": false},
//             {"position": {"x": 5, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 5}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             {"position": {"x": 2, "y": 6}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             {"position": {"x": 3, "y": 4}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             // {"position": {x: 4, y: 4}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             // {"position": {x: 5, y: 0}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//             {"position": {"x": 0, "y": 1}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//             {"position": {"x": 5, "y": 1}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/mountain_1.png")},
//             {"position": {"x": 5, "y": 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//         ]
//     },
//     "spawns": [
//         {"position": {"x": 1, "y": 1}, "affiliation": "good"},
//         // {"position": {x: 2, y: 0}, "affiliation": "good"},
//         // {"position": {x: 3, y: 0}, "affiliation": "good"},
//         // {"position": {x: 4, y: 0}, "affiliation": "good"},
//         // {"position": {x: 2, y: 1}, "affiliation": "good"},
//
//         {"position": {"x": 4, "y": 1}, "affiliation": "bad", "classKey": "archer", "maxhealth": 10},
//         {"position": {"x": 5, "y": 5}, "affiliation": "bad", "classKey": "berserker", "maxhealth": 20},
//         {"position": {"x": 3, "y": 7}, "affiliation": "bad", "classKey": "berserker", "maxhealth": 20},
//     ],
//     "events": {
//         "0:start": [
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana", "side": "right",
//                     "text": "Oof.. Where am I?",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana", "side": "right",
//                     "text": "I'll figure out where I am after I defeat these enemies.",
//                 }
//             },
//             {
//                 "type": "StopDialogue"
//             }
//         ]
//     },
//     "afterVictory": [
//         {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
//         {"type": "FinishLocation", "locationKey": "1"},
//         {"type": "DisplayLocations", "locationKeys": ["2"]},
//         {"type": "DisplayLocations", "locationKeys": ["3"]},
//         {"type": "DisplayLocations", "locationKeys": ["4"]},
//         {"type": "DisplayLocations", "locationKeys": ["5"]},
//         {"type": "DisplayEventualRoute", "routeKeys": ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"]},
//         {"type": "Wait", "time": 1},
//         {"type": "UnlockLocations", "locationKeys": ["2"], "routeKeys": ["1", "2", "3"]},
//     ],
//     "nextUrl": "/games/hero/chapters/introduce-archer",
// },
